'use client'

import useSWR from "swr";
import { useEffect } from "react";

// Add Google Identity API type definitions
declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: any) => void;
          renderButton: (parent: HTMLElement, options: any) => void;
          prompt: (callback: (notification: any) => void) => void;
        };
      };
    };
  }
}

function loadGoogleIdentityScript(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') return resolve()
    
    // If script already exists and API is loaded, resolve immediately
    if (window.google?.accounts?.id) {
      return resolve()
    }
    
    // If script exists but API not loaded yet, wait for it
    const existingScript = document.querySelector('script[src*="accounts.google.com/gsi/client"]')
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve())
      return
    }

    // Create and load new script
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    document.head.appendChild(script)
  })
}

export function useGoogleIdentity() {
  const { data: googleIdentity, mutate } = useSWR(
    'google-identity',
    async () => {
      await loadGoogleIdentityScript()
      return window.google
    },
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  return { googleIdentity, recheckGoogleIdentity: () => mutate() }
}

export const GOOGLE_CLIENT_ID = '91285510383-utd4qqqv3fbt67d1fob5ar7priv9kkap.apps.googleusercontent.com' 